<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Profile</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <div class="user-profile-main-section col-12 float-l">
                    <div class="row">

                        <div class="user-profile-top-section float-l col-12 default-bx-shadow bg-color-ffffff"> <!--top section-->
                            <div class="row">

                                <div class="user-image float-l"> <!--user image-->
                                    <img src="/static/images/avtar-img-1.jpg" alt="User Name">
                                    <a href="#"><i class="hi-icon icon-abmnew-file user-edit-icon"> </i></a>
                                </div> <!--user image-->

                                <div class="user-detail-section float-l"> <!--user detail-->
                                    <h1 class="color-71aa3f heading-text-28 line-height-32 float-l width-full font-text-regular-san mb-0"> Elizabeth Lizarraga </h1>
                                    <h6 class="color-7a7a7a heading-text-15 line-height-20 float-l width-full font-text-regular-san mb-0"> Director of Human Resources, VVG </h6>
                                    <p class="user-join-date float-l width-full color-7a7a7a heading-text-15 line-height-20 float-l width-full font-text-regular-san mb-0 pt-15"> Joining on <span class="font-text-bold-san"> 23rd August, 2016 </span> </p>
                                </div> <!--user detail-->

                                <div class="user-detail-btm float-l col-12"> <!--User btm section-->
                                    <div class="row">
                                        <div class="user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30">
                                            <h6 class="user-title-top"> Address </h6>
                                            <p> 795 Folsom Ave, Suite 600, San Francisco, CADGE 94107 </p>
                                        </div>

                                        <div class="user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30">
                                            <h6 class="user-title-top"> Email Address </h6>
                                            <a href="mailto:elizabeth.lizarranga@vvg.com"> elizabeth.lizarranga@vvg.com </a>
                                        </div>

                                        <div class="user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30">
                                            <h6 class="user-title-top"> Phone # </h6>
                                            <ul>
                                                <li>
                                                    <div class="detail-title"> Mobile:</div>
                                                    <div class="detail-sec"> + 800 123 5678 </div>
                                                </li>

                                                <li>
                                                    <div class="detail-title"> Landline: </div>
                                                    <div class="detail-sec"> + (123) 456-7890 </div>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="user-detail-sec float-l col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 mb-30">
                                            <h6 class="user-title-top"> Roles </h6>
                                            <ul>
                                                <li>
                                                    Project Manager
                                                </li>

                                                <li>
                                                    Administrator
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div> <!--User btm section-->

                            </div>
                        </div> <!--top section-->

                        <div class="user-profile-top-section float-l col-12 default-bx-shadow bg-color-ffffff mt-50"> <!--bottom section-->
                            <div class="row">
                                <h6 class="user-title-top"> Bio </h6>
                                <p class="user-join-date float-l width-full color-7a7a7a heading-text-15 line-height-20 float-l width-full font-text-regular-san mb-0 pt-8"> Born on <span class="font-text-bold-san"> 9th April, 1990 </span> </p>

                                <p class="color-7a7a7a heading-text-16 line-height-22 float-l width-full font-text-regular-san mb-0 pt-25"> Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. </p>
                            </div>
                        </div> <!--bottom section-->

                    </div>
                </div>

            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/footer';
    export default {
        name: 'Center',
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/profile.vue